
/* System defined core library */
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverConfig, PopoverModule } from 'ngx-bootstrap/popover';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';

/* User defined library/components */
import { AppointmentService } from '../../scheduling/shared/services/appointment/appointment.service';
import { FocusDirective } from '../baseclass/setFocus.directive';
import { CloseButtonComponent } from '../components/button/close-button.component';
import { GenericButtonComponent } from '../components/button/generic-button.component';
import { NextButtonComponent } from '../components/button/next-button.component';
import { PrevButtonComponent } from '../components/button/prev-button.component';
import { CardComponent } from '../components/card/card.component';
import { ContentComponent } from '../components/content/content.component';
import { CaptchaComponent } from '../components/captcha/captcha.component';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { DynamicFormControlComponent } from '../components/dynamic-form-control/dynamic-form-control.component';
import { DynamicFormComponent } from '../components/dynamic-form/dynamic-form.component';
import { FooterComponent } from '../components/footer/footer.component';
import { GeoLocatorComponent } from '../components/geo-locator/geo-locator.component';
import { HeaderComponent } from '../components/header/header.component';
import { NavbarBrandRight } from '../components/header/navbar-brand-right/navbar-brand-right.component';
import { NavbarLang } from '../components/header/navbar-lang/navbar-lang.component';
import { HomeComponent } from '../components/home/home.component';
import { LoaderComponent } from '../components/loader/loader.component';
import { PopoverComponent } from '../components/popover/popover.component';
import { PrintComponent } from '../components/print/print.component';
import { RequiredComponent } from '../components/required/required.component';
import { ToggleComponent } from '../components/toggle/toggle.component';
import { LocalizedDatePipe } from '../pipes/localizedDate.pipe';
import { DeepLinkingService } from '../services/deep-linking.service';
import { DemographicsService } from '../services/demographics.service';
import { DynamicComponentService } from '../services/dynamic.component.service';
import { ExamFeatureService } from '../services/exam-feature.service';
import { GlobalErrorHandlerService } from '../services/global-error-handler.service';
import { RoutingService } from '../services/routing.service';
import { TimerService } from '../services/timer.service';
import { UtilityService } from '../services/utility.service';


export function getPopoverConfig(): PopoverConfig {
    return Object.assign(new PopoverConfig(), { placement: 'right', container: '', triggers: 'click' });
}

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        BsDatepickerModule.forRoot(),
        TypeaheadModule.forRoot(),
        TooltipModule.forRoot(),
        PopoverModule
    ],
    declarations: [
        LocalizedDatePipe,
        DatepickerComponent,
        HomeComponent,
        PopoverComponent,
        HeaderComponent,
        NavbarBrandRight,
        NavbarLang,
        FooterComponent,
        GeoLocatorComponent,
        LoaderComponent,
        DynamicFormControlComponent,
        DynamicFormComponent,
        ContentComponent,
        PrintComponent,
        CardComponent,
        RequiredComponent,
        ToggleComponent,
        GenericButtonComponent,
        NextButtonComponent,
        PrevButtonComponent,
        CloseButtonComponent,
        FocusDirective,
        CaptchaComponent
    ],
    providers: [
        LocalizedDatePipe,
        UtilityService,
        DeepLinkingService,
        { provide: PopoverConfig, useFactory: getPopoverConfig },
        ExamFeatureService,
        RoutingService,
        AppointmentService,
        DemographicsService,
        DynamicComponentService,
        TimerService,
        GlobalErrorHandlerService,
        { provide: ErrorHandler, useClass: GlobalErrorHandlerService }
    ],
    exports: [
        LocalizedDatePipe,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        DatepickerComponent,
        GeoLocatorComponent,
        HomeComponent,
        PopoverComponent,
        HeaderComponent,
        NavbarBrandRight,
        NavbarLang,
        FooterComponent,
        LoaderComponent,
        DynamicFormControlComponent,
        DynamicFormComponent,
        ContentComponent,
        PrintComponent,
        CaptchaComponent,
        CardComponent,
        RequiredComponent,
        ToggleComponent,
        GenericButtonComponent,
        NextButtonComponent,
        PrevButtonComponent,
        CloseButtonComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule { }
